import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from 'baseui/button'
import { FormattedMessage } from 'react-intl';
import { DefaultScopes } from "../../msalConfig";

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignInButton = () => {
    const { instance, inProgress } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(DefaultScopes).catch((e: any) => {
            console.error(e);
        });
    }

    return (
        <Button overrides={{
            BaseButton: { style: { width: "200px" } }
        }} shape='pill' onClick={handleLogin}><FormattedMessage id="SignInButton.text" defaultMessage="Login" /></Button>
    );


}